import { defaults } from 'lodash';

export enum RecoveryMode {
    none = 'none', // Always throw the server error.
    retryOnNetworkError = 'retryOnNetworkError' // If this error is network error keep retrying until connection is back else throw the error.
}

interface RetryOnNetworkErrorDelayOptions {
    delay?: number;
    incrementalDelay?: {
        startAfterRetries: number;
        backoff: number;
        max: number;
    };
    informUnstableConnectionAfterRetries?: number;
}

const RetryOnNetworkErrorDelayOptionsDefaults: RetryOnNetworkErrorDelayOptions =
    {
        delay: 5000,
        informUnstableConnectionAfterRetries: 3
    };

export type RecoveryModeOptions = RetryOnNetworkErrorDelayOptions;

export const RecoveryModeOptionsDefaultsDictionary: Record<
    RecoveryMode,
    RecoveryModeOptions
> = {
    [RecoveryMode.none]: null,
    [RecoveryMode.retryOnNetworkError]: RetryOnNetworkErrorDelayOptionsDefaults
};

export const recoveryModeOptionsOptionsFactory = (
    recoveryMode,
    userOptions: RecoveryModeOptions
) => defaults(userOptions, RecoveryModeOptionsDefaultsDictionary[recoveryMode]);
